module.exports = __webpack_public_path__ + "img/tyh4.cc6cf694.jpg";